import { useTranslation } from "react-i18next";
import { useTheme, type ThemePref } from "./theme";

// Theme switcher: a 3-way segmented control (System / Light / Dark). The chosen
// option is aria-pressed and visually raised (shape cue, not colour alone). The
// whole group is labelled for assistive tech.
const OPTIONS: { pref: ThemePref; glyph: string }[] = [
  { pref: "system", glyph: "◐" },
  { pref: "light", glyph: "☀" },
  { pref: "dark", glyph: "☾" },
];

export function ThemeToggle() {
  const { t } = useTranslation();
  const [pref, setPref] = useTheme();

  return (
    <div className="theme-toggle" role="group" aria-label={t("app.theme.label")}>
      {OPTIONS.map(({ pref: opt, glyph }) => {
        const label = t(`app.theme.${opt}`);
        return (
          <button
            key={opt}
            type="button"
            className="theme-toggle__btn"
            aria-pressed={pref === opt}
            aria-label={label}
            title={label}
            onClick={() => setPref(opt)}
          >
            <span aria-hidden="true">{glyph}</span>
          </button>
        );
      })}
    </div>
  );
}
